import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import axios from "axios";
import { connect, useSelector } from "react-redux";
import images from "../../../utilities/images/images";
import { isEmpty } from "../../../custom_utilities/custom_useful_functions";
import { url_152, url_273 } from "../../../custom_utilities/api_services";
//Redux
import uiActions from "../../../redux/ui/action";
import useAuthUtils from "../../../hooks/auth/useAuthUtils";
import PDFViewer from "./PdfViewer";
import { toastifyMessage } from "../../../custom_utilities/toastify_config";

const CuetTopics = (props) => {
  const { headers } = useAuthUtils();

  let { userPreference, startLoading, finishLoading } = props;

  const currentCuetPracticeData = useSelector(
    (state) => state?.CuetSlice?.currentCuetPracticeData
  );

  const currentCueSubject = useSelector(
    (state) => state?.CuetSlice?.currentCuetSubjectData
  );

  const [topics, setTopics] = useState([]);
  const [pdfData, setPdfData] = useState(null);

  let history = useHistory();

  useEffect(() => {
    getTopicList();
  }, []);

  const getTopicList = async () => {
    let data = {
      course_id: userPreference.courseDetails[0].course_id,
      subject_id: currentCueSubject?.sub_id,
    };
    startLoading();
    try {
      const response = await axios.post(url_152, data);
      if (response.data.status === 200) {
        setTopics(response.data.data.topic);
        finishLoading();
      }
      finishLoading();
    } catch (error) {
      console.log(error);
    } finally {
      finishLoading();
    }
  };

  const renderPdf = async (elem) => {
    startLoading();
    try {
      const response = await axios(
        `${url_273}?practice_id=${currentCuetPracticeData.id}&subject_id=${currentCueSubject?.sub_id}&topic_id=${elem.topic_id}`,
        { headers }
      );

      if (response.data.status === 200) {
        finishLoading();
        if (response.data.data.length === 0) {
          toastifyMessage({
            status: 500,
            message: "PDF not found for the selected topic.",
          });
        } else {
          setPdfData(response.data.data[0]);
        }
      }

      console.log("response of final", response);
    } catch (err) {
      console.log(err.message);
    } finally {
      finishLoading();
    }
  };

  return (
    <>
      <div className="pyq_subjectTopicWrapper">
        <div className="container">
          <div className="pyq_subjectTopicInner">
            {!pdfData ? (
              <div className="pyqSbjTpcListBox">
                <div className="d-flex">
                  <div className="backBtn" onClick={() => history.goBack()}>
                    <img src={images.m2_backBtn} alt="backBtn" />
                  </div>

                  <h1 className="subject_name d-inline-block mx-auto">
                    {currentCueSubject?.sub_name}
                  </h1>
                </div>
                <div
                  className="subject_topic_list"
                  style={{ height: "64vh", overflow: "auto", padding: "8px" }}
                >
                  {!isEmpty(topics)
                    ? topics.length
                      ? topics.map((elem, index) => {
                          return (
                            <div
                              className="subject_topics"
                              key={index}
                              onClick={() => renderPdf(elem)}
                            >
                              <div className="sbjct_tpc_name">
                                {elem.topic_name}
                              </div>
                              <div className="arrow">
                                <img src={images.m2_rgtArow} alt="arrow" />
                              </div>
                            </div>
                          );
                        })
                      : null
                    : null}
                </div>
              </div>
            ) : (
              <div>
                <div className="backBtn" onClick={() => setPdfData(null)}>
                  <img src={images.m2_backBtn} alt="backBtn" />
                </div>

                <PDFViewer pdfData={pdfData}/>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    userPreference: state.userPreference,
    pyqtopicData: state.userActivity.pyqtopicData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    startLoading: () => {
      dispatch(uiActions.startLoading());
    },
    finishLoading: () => {
      dispatch(uiActions.finishLoading());
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CuetTopics);
